import { render, staticRenderFns } from "./a-list-table.vue?vue&type=template&id=18fb4470&scoped=true"
import script from "./a-list-table.vue?vue&type=script&lang=js"
export * from "./a-list-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fb4470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18fb4470')) {
      api.createRecord('18fb4470', component.options)
    } else {
      api.reload('18fb4470', component.options)
    }
    module.hot.accept("./a-list-table.vue?vue&type=template&id=18fb4470&scoped=true", function () {
      api.rerender('18fb4470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/maudiences/views/a-list-table.vue"
export default component.exports